import React, { FC } from 'react';

import { useIsMobile } from '../../../../utils';
import { useRenderers } from '../../../../renderProps';
import FirstLoginAgreementBase, { Props as FirstLoginAgreementProps } from './FirstLoginAgreement';
import { ModalX, ModalXProps } from '../../../../BaseComponents';

interface Props {
	modalProps: ModalXProps;
	firstLoginAgreementProps: FirstLoginAgreementProps;
}

const FirstLoginAgreementModal: FC<Props> = ({ modalProps, firstLoginAgreementProps }) => {
	const isMobile = useIsMobile();

	const { FirstLoginAgreement: FirstLoginAgreementOverride = FirstLoginAgreementBase } = useRenderers();

	return (
		<ModalX ignoreClose size={isMobile ? 'fullscreen' : 'medium'} {...modalProps}>
			<FirstLoginAgreementOverride {...firstLoginAgreementProps} />
		</ModalX>
	);
};

export default FirstLoginAgreementModal;
